import React from 'react';
import { IAllProps } from '@tinymce/tinymce-react';
import { Box } from '@apia/theme';

interface ITranslateEditor {
  value: string;
  onSetLocalValue: (newValue: string) => void;
  onFlush: () => void | undefined;
}

const Editor = React.lazy<React.FunctionComponent<IAllProps>>(() => {
  const component: Promise<{
    default: React.FunctionComponent<IAllProps>;
  }> | void = import(
    /* webpackChunkName: "apia-execution-LazyApiaEditor" */ '../../../execution/fields/LazyApiaEditor'
  ).catch(console.error) as unknown as Promise<{
    default: React.FunctionComponent<IAllProps>;
  }>;

  return component;
});

const TranslateEditor = ({
  onSetLocalValue,
  value,
  onFlush,
}: ITranslateEditor) => {
  return (
    <Box className="editor__field">
      <React.Suspense>
        <Editor
          init={{
            a11y_advanced_options: true,
            skin: false,
            content_css: false,
            content_style:
              '#tinymce {padding: 12px; color: #4a4a4a; font-family: sans-serif; font-size: 1em}',
            // language:
            // `${Config.LANG_CODE}_${Config.LANG_CODE.toUpperCase()}`,
            height: '100%',
            branding: false,
            browser_spellcheck: true,
            contextmenu: false,
            relative_urls: false,
            remove_script_host: false,
            menubar: 'file edit view insert format tools table help',
            fontsize_formats: '8px 10px 12px 14px 16px 18px 24px 36px 48px',
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat ',
          }}
          value={value}
          onBlur={onFlush}
          onKeyDown={(e) => {
            if (e.key.toLowerCase() === 'enter') {
              onFlush();
            }
          }}
          onEditorChange={(newValue) => {
            onSetLocalValue(newValue);
          }}
        />
      </React.Suspense>
    </Box>
  );
};

export default TranslateEditor;
